import { render, staticRenderFns } from "./ArticleListContent.vue?vue&type=template&id=1be71422&scoped=true&"
import script from "./ArticleListContent.vue?vue&type=script&lang=js&"
export * from "./ArticleListContent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListContent.vue?vue&type=style&index=0&id=1be71422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be71422",
  null
  
)

export default component.exports